class ChartDataBuilder {
	constructor(type, series, categories) {
		this.type = type;
		this.series = series;
		this.categories = categories;
	}

	generatechartData() {
		let chartData;
		switch (this.type) {
		case 'line':
			chartData = this.generateLineChart();
			break;
		case 'bar':
			chartData = this.generateBarChart();
			break;
		case 'area':
			chartData = this.generateAreaChart();
			break;
		case 'singlebar':
			chartData = this.generateSingleBarChart();
			break;
		case 'radar':
			chartData = this.generateRadarChart();
			break;
		case 'boxPlot':
			chartData = this.generateBoxPlotChart();
			break;
		default:
			throw new Error('GRAPHIC_NOT_EXIST');
		}

		return chartData;
	}

	generateLineChart() {
		return {
			type: 'line',
			series: this.series,
			options: {
				chart: {
					type: 'line',
				},
				xaxis: {
					categories: this.categories,
				},
			},
		};
	}

	generateBarChart() {
		return {
			series: this.series,
			options: {
				chart: {
					type: 'bar',
					height: 350,
				},
				plotOptions: {
					bar: {
						borderRadius: 0,
						horizontal: true,
						barHeight: '80%',
						isFunnel: true,
					},
				},
				dataLabels: {
					enabled: true,
					formatter(val, opt) {
						return `${opt.w.globals.labels[opt.dataPointIndex]}:  ${val}`;
					},
					dropShadow: {
						enabled: true,
					},
				},
				// title: {
				// 	text: 'Recruitment Funnel',
				// 	align: 'middle',
				// },
				xaxis: {
					categories: this.categories,
				},
				dataProvider: [{ title: 'A', value: 1000 }],
			},
		};
	}

	generateAreaChart() {
		return {
			series: this.series,
			options: {
				chart: {
					height: 350,
					type: 'area',
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					curve: 'smooth',
				},
				xaxis: {
					categories: this.categories,
					labels: {
						style: {
							fontSize: '8px',
						},
					},
				},
			},
		};
	}

	generateSingleBarChart() {
		return {
			series: this.series,
			options: {
				chart: {
					type: 'bar',
					height: 900,
				},
				plotOptions: {
					bar: {
						borderRadius: 0,
						borderRadiusApplication: 'end',
						horizontal: true,
					},
				},
				colors: ['#f09c2b'],
				dataLabels: {
					enabled: false,
				},
				xaxis: {
					categories: this.categories,
					labels: {
						show: false,
					},
				},
				yaxis: {
					labels: {
						style: {
							fontSize: '8px',
						},
					},
				},
			},
		};
	}

	generateRadarChart() {
		return {
			series: this.series,
			options: {
				chart: {
					// height: 250,
					type: 'radialBar',
				},
				plotOptions: {
					radialBar: {
						hollow: {
							size: '45%',
						},
						dataLabels: {
							name: {
								show: false,
								fontSize: '8px',
							},
							value: {

								fontSize: '16px',
							},
						},
					},
				},
				colors: ['#f09c2b'],
				labels: this.categories,
			},
		};
	}

	generateBoxPlotChart() {
		return {
			series: this.series,
			options: {
				chart: {
					type: 'boxPlot',
					height: 400,
					fontFamily: 'inherit',
					toolbar: { show: false },
				},
				plotOptions: {
					boxPlot: {
						colors: {
							upper: '#55ac4b',
							lower: '#005CAF',
						},
					},
				},
				xaxis: {
					categories: this.categories,
					labels: {
						style: {
							fontSize: '11px',
							fontWeight: 500,
						},
					},
				},
				yaxis: {
					labels: {
						style: {
							fontSize: '11px',
							fontWeight: 500,
						},
					},
				},
				grid: {
					show: true,
					borderColor: '#f1f5f9',
					strokeDashArray: 0,
				},
				tooltip: {
					enabled: true,
					theme: 'light',
				},
			},
		};
	}
}

export default ChartDataBuilder;



// WEBPACK FOOTER //
// ./src/shared/chart-builder.js